<template>
   <div>
       <button class="btn btn-success" @click="openModal('create-serie-modal')">
           <i class="fa fa-plus-circle"></i> New Series
       </button>
       <modal id="create-serie-modal">
           <template slot="title">New Series</template>
           <template slot="body">
               <field-input v-model="form.title" placeholder="Title"></field-input>
               <field-text v-model="form.description" placeholder="Description"></field-text>
               <field-datetime v-model="form.published_at" :with-time="false" :clear-button="true" :emit-null="true" label="Publish Date"></field-datetime>
           </template>
           <template slot="footer">
               <button class="btn btn-default" type="button" @click="closeModal('create-serie-modal')">Close</button>
               <button class="btn btn-success" type="button" @click="save()">Save</button>
           </template>
       </modal>
   </div>
</template>
<script>
    export default {

        data(){
            return {
                form: new Form({
                    title: '',
                    description: '',
                    published_at: null,
                })
            }
        },

        methods: {
           save(){
               this.form.post(`/training/series`).then(response => {
                   Toast.success(`Video Created Successfully!`)
                   this.refreshPage();
               }).catch(errors => {
                   Alert.error(errors.first())
               })
           }
        },
    }
</script>
